import React, { useEffect, useState } from 'react';
import ApexCharts from 'apexcharts';
import { Box } from '@mui/material';

/* eslint-disable react/prop-types */
export default function DonutApexChart({ name, data }) {
  const [idname] = useState(name);
  const [renderChart, setRenderChart] = useState(false);

  const options = {
    series: data?.percentage,
    labels: data?.label?.map(
      (row, i) =>
        `${row}: ${Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(data.value[i])}`,
    ),
    chart: {
      type: 'donut',
      height: 460,
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            offsetY: 40,
            total: {
              show: true,
              offsetX: 1000,
              offsetY: 1000,
              label: `Total Percentage`,
              fontSize: '22px',
              fontWeight: 'bold',

              formatter: () => `${data?.total_percentage.toFixed(2)}%` ?? '',
            },
          },
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  useEffect(() => {
    if (renderChart) {
      const chart = new ApexCharts(document.querySelector(`#${idname}`), options);
      chart.render();
    }

    setRenderChart(true);
  }, [renderChart]);

  return (
    <Box>
      <div
        id={idname}
        style={{
          '.apexcharts-text': {
            fontWeight: 'bold',
          },
        }}
      />
    </Box>
  );
}
